export default {
    accept_document: "Qəbul et",
    agreement_status_not_signed: "İmzalanmayıb",
    agreement_status_signed: "İmzalanıb",
    all_other_countries: "Digər bütün ölkələr",
    effective_at: "Qüvvəyə minmə tarixi",
    legal_agreement: "Saziş",
    legal_document: "Hüquqi sənəd",
    legal_document_countries_note: "Heç bir ölkə seçilmərsə, sənəd bu növdə öz sənədi olmayan bütün ölkələrə tətbiq olunur.",
    legal_document_is_active_note: "Hər sənəd növü və bölgəsi üçün yalnız bir versiya aktiv ola bilər. Bu versiyanı aktivləşdirmək əvvəlki aktiv versiyanı avtomatik deaktiv edir.",
    legal_document_must_accept_note: "Davam etmək üçün sənədlə tanış olub onu qəbul etməlisiniz.",
    legal_document_superadmin_authority_note: "Sənədi qəbul etməklə siz təşkilat adından hərəkət etmək səlahiyyətinizin olduğunu təsdiqləyirsiniz.",
    legal_document_type: "Sənəd növü",
    legal_document_type_offer_contract: "Oferta müqaviləsi",
    legal_document_type_integrations_agreement: "Üçüncü tərəf xidmətləri və inteqrasiyalardan istifadə müqaviləsi",
    legal_document_type_usage_agreement: "Proqramdan istifadə müqaviləsi",
    legal_document_usage_agreement_note: "Sənədi qəbul etməklə siz proqramdan istifadə qaydaları ilə tanış olduğunuzu və onlara əməl etməyi öhdənizə götürdüyünüzü təsdiqləyirsiniz.",
    legal_documents: "Hüquqi sənədlər",
    loading: "Yüklənir",
    no_legal_documents_for_region: "Sizin bölgəniz üçün hələ heç bir sənəd dərc edilməyib",
    open_document: "Sənədi aç",
    requires_reacceptance: "Yenidən qəbul tələb olunur",
    requires_reacceptance_note: "Aktiv edilərsə, əvvəlki versiyanı qəbul etmiş istifadəçilər növbəti girişdə bu versiyanı yenidən qəbul etməli olacaqlar.",
    version: "Versiya"
}
